import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAlert } from '../contexts/AlertContext';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const LoginPage = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useAlert();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_BASE_URL}/api/auth/login`, formData);
      
      // 토큰을 localStorage에 저장
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('userType', 'student');
      
      // 사용자 정보를 가져와서 저장
      const userResponse = await axios.get(`${API_BASE_URL}/api/auth/me`, {
        headers: {
          'Authorization': `Bearer ${response.data.access_token}`
        }
      });
      localStorage.setItem('user', JSON.stringify(userResponse.data));
      
      showSuccess('로그인이 성공적으로 완료되었습니다!');
      navigate('/');
      
    } catch (error) {
      console.error('Login error:', error);
      if (error.response?.data?.detail) {
        setError(error.response.data.detail);
      } else {
        setError('로그인 중 오류가 발생했습니다.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="login-container">
        <div className="card login-card">
          <h2>Login</h2>
          <p>이메일과 비밀번호를 입력해주세요</p>
          
          {error && (
            <div className="error-message">
              ⚠️ {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">이메일</label>
              <input
                type="email"
                className="form-input"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                placeholder="your@email.com"
                required
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">비밀번호</label>
              <input
                type="password"
                className="form-input"
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
                placeholder="비밀번호를 입력하세요"
                required
              />
            </div>
            
            <div className="form-group">
              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={loading}
                style={{width: '100%'}}
              >
                {loading ? '로그인 중...' : '로그인'}
              </button>
            </div>
          </form>

          <div className="login-links">
            <p>아직 계정이 없으신가요?</p>
            <button 
              className="btn btn-secondary"
              onClick={() => navigate('/register')}
              style={{marginTop: '10px', width: '100%'}}
            >
              회원가입하기
            </button>
            
            <div style={{marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '5px'}}>
              <p style={{margin: '0', fontSize: '14px', color: '#666'}}>
                <strong>관리자이신가요?</strong><br/>
                <button 
                  className="btn btn-link"
                  onClick={() => navigate('/admin/login')}
                  style={{padding: '5px 0', fontSize: '14px'}}
                >
                  관리자 로그인
                </button>
              </p>
            </div>
            
            <div style={{marginTop: '20px', padding: '15px', backgroundColor: '#e3f2fd', borderRadius: '5px'}}>
              <p style={{margin: '0', fontSize: '14px', color: '#1976d2'}}>
                💡 <strong>게스트로 이용하고 싶으신가요?</strong><br/>
                <button 
                  className="btn btn-link"
                  onClick={() => navigate('/test')}
                  style={{padding: '5px 0', fontSize: '14px', color: '#1976d2'}}
                >
                  게스트 모드로 게임 체험하기
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 